import { useEffect } from 'react';
import { initAppFeedback } from '@/lib/feedbackWidget';

/** 在 App（後台）上掛載「畫面標記回饋」浮動鈕。回饋會記到測試報告的對應功能區塊。
 *  以 vanilla 單例實作（initAppFeedback 內部防重複），這裡只負責掛載一次。 */
export function FeedbackWidget() {
  useEffect(() => {
    initAppFeedback();
  }, []);
  return null;
}
